import * as Yup from 'yup';

const editReferrerSchema = Yup.object().shape({
  bankName: Yup.string()
      .typeError('Nama Bank harus diisi')
      .required('Nama Bank harus diisi'),
  accountNumber: Yup.string()
      .required('Nomor Rekening harus diisi')
      .matches(/^[0-9]*$/, 'Nomor Rekening harus berupa angka')
      .min(10, 'Nomor Rekening minimal 10 digit')
      .max(16, 'Nomor Rekening maksimal 16 digit'),
  accountName: Yup.string()
      .trim('Tidak dapat mengisi hanya dengan spasi')
      .matches(/^[A-Za-z ]*$/, 'Nama Pemilik hanya boleh berisi huruf dan spasi')
      .required('Nama Pemilik Rekening harus diisi')
      .max(60, 'Nama tidak boleh lebih dari 60 karakter.'),
  npwpStatus: Yup.string()
      .required('Pilihan NPWP harus diisi'),
  npwpNumber: Yup.string()
      .when('npwpStatus', {
          is: '01',
          then: Yup.string().required('Nomor NPWP harus diisi jika Anda memilih Ya pada pilihan NPWP.')
              .matches(/^\d{2}\.\d{3}\.\d{3}\.\d{1}-\d{3}\.\d{3}$/, 'Nomor NPWP tidak valid'),
          otherwise: Yup.string().notRequired().matches(/^\d{2}\.\d{3}\.\d{3}\.\d{1}-\d{3}\.\d{3}$/, 'Nomor NPWP tidak valid'),
      })
})

export default editReferrerSchema;